<app-navbar></app-navbar>    

<div id="main-content" class="animated fadeIn">
    <div class="container-fluid">
    <!-- contenido-->
    <div class="block-header">
        <div class="row clearfix">
            <div class="col-md-6 col-sm-12">
                <h1 class="color">Agregar Usuarios</h1>
                <div class="header">
                    <p style="cursor: pointer;" class="color" [routerLink]="['/home']"><i class="fa fa-angle-left " style="font-size: 19px;" aria-hidden="true"></i> Gestor de Tareas / <span class="" style="color: #a5a8ad;">Agregar Usuarios</span></p>
                </div>
            </div>            
        </div>
    </div>



        <div class="row">
            <div class="col-lg-6 col-md-6 col-6 col-sm-12">
              <div class="card">
                <div class="header">
                  <h2>Invitar Usuario Registrado</h2>		          
                </div>
                <div class="body">
                    <div class="row justify-content-center">	
                          <form #userRegister="ngForm" (ngSubmit)="onSubmitRegister(userRegister)" class="col-md-8">
                            <div class="form-group">
                                <label for="email">Email</label>
                                <input name="email" type="email" email class="form-control round" #email="ngModel" [(ngModel)]="adduser.email" name="email" required>
                                <span *ngIf="!email.valid && email.touched">
                                  El email no es válido
                                </span>
                            </div>
                            <div class="form-group">
                                <button type="submit"  [disabled]="!userRegister.form.valid" class=" btn btn-primary btn-round btn-block">
                                  <i class="fa " aria-hidden="true" [ngClass]="{ 'fa-save':!loadingUser, ' fa-refresh fa-spin':loadingUser }"></i>
                                  Guardar
                                </button>
                            </div>
                          </form> 
                    </div>  
                </div>
              </div>



              <div class="row">
                <div class="col-lg-12 col-md-12 col-12 col-sm-12">
                  <div class="card">
                    <div class="header">
                      <h2>Equipo</h2>		          
                    </div>
                    <div class="body">
                        <div class="">
                          <div class="row">
            
                            <table class="table table-striped">
                              <thead>
                                <tr>
                                  <th scope="col">Usuario</th>
                                  <th scope="col">Eliminar</th>
                                </tr>
                              </thead>
                              <tbody>				   
            
                                  
                                <tr *ngFor="let us of agregar_usuario?.usuarios">
                                  <td>
                                    <div class="container">
                                      <div class="row">
                                        <p style="color:#a5a8ad" *ngIf="us.name != null">{{us.name}} {{us.last_name}}</p>
                                        <p style="color:#a5a8ad" *ngIf="us.name == null">En espera de Registro</p>
                                      </div>
                                      <div class="row">
                                        {{us.email_usuario}}
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    <button type="button" class="btn btn-danger btn-round btn-block" (click)="elimina_usuario_equipo(us.id_equipo)"><i class="fa fa-trash" aria-hidden="true"></i></button>
                                  </td>
                                </tr>
                                    
                            
                                
                              </tbody>
                            </table>
                            </div>
            
            
                        </div>  
                    </div>
                  </div>
                </div>
             </div>


            </div>
         <!-- end col -6 -->
        
         <!-- <div class="row"> -->
             
            <div class="col-lg-6 col-md-6 col-6 col-sm-12">
              <div class="card">
                <div class="header">
                  <h2>Invitar Cliente</h2>		          
                </div>
                    <div class="body">

                     <div class="container">
                      <ngb-tabset justify="justified">
                        <ngb-tab title="Clientes Registrados">
                          <ng-template ngbTabContent>
                           
                            <form #agregausuarioform="ngForm" (ngSubmit)="onSubmitUser(agregausuarioform)" class="col-12">
                              <div class="form-group">
                                  <label for="email">Proyecto</label>
                                <select name="proyecto" required class="form-control round" #proyecto="ngModel" [(ngModel)]="addcliente.proyecto">
                                    <option *ngFor="let proy of agregar_usuario?.proyectos" value="{{proy.id}}">{{proy.categoria}}</option>
                                </select>	
                              </div>	    
                              <div class="form-group">
                                  <label for="email">Email</label>
                                  <input type="email" class="form-control round" #emailC="ngModel" [(ngModel)]="addcliente.email" name="email" placeholder="Email" required 
                                    [ngClass]="{'is-invalid' : status == 'error'}"
                                    #emailC="ngModel" [(ngModel)]="addcliente.email"
                                    >
                              </div>
                              <span *ngIf="!email.valid && email.touched">
                                  El email no es válido
                              </span>
                              <div class="form-group">
                                  <button type="submit"  [disabled]="!agregausuarioform.form.valid" id="btn-contact" class="btn btn-primary btn-round btn-block">
                                    <i class="fa " aria-hidden="true" [ngClass]="{ 'fa-save':!loadingCliente, ' fa-refresh fa-spin':loadingCliente }"></i>
                                    Guardar
                                  </button>
                              </div>
                              </form>



                          </ng-template>
                        </ngb-tab>
                        <ngb-tab>
                          <ng-template ngbTabTitle>Clientes sin Registro</ng-template>
                          <ng-template ngbTabContent>
                            
                            
                            <form #agregausuariosinRform="ngForm" (ngSubmit)="onSubmitClienteR(agregausuariosinRform)" class="col-12">
                                  <div class="row">
                                      <div class="col-6">
                                              <div class="form-group">
                                             <label for="text">Nombre</label>
                                             <input name="name" type="text" class="form-control round" required #nombreCR="ngModel" [(ngModel)]="addclienteRegister.nombre">
                                         </div>
                                      </div>
                                      <div class="col-6">
                                              <div class="form-group">
                                             <label for="text">Apellido</label>
                                             <input name="apellido" type="text" class="form-control round" required #apellidoCR="ngModel" [(ngModel)]="addclienteRegister.apellido">
                                         </div>
                                      </div>
                                 </div>
                                <div class="form-group">
                                    <label for="email">Email</label>
                                    <input name="email" type="email" email class="form-control round" required #emailCR="ngModel" [(ngModel)]="addclienteRegister.email">
                                </div>
                                <div class="form-group">
                                    <label for="email">Proyecto</label>
                                    <select name="proyecto" required class="form-control round" required #proyectoCR="ngModel" [(ngModel)]="addclienteRegister.proyecto">
                                        <option *ngFor="let proy of agregar_usuario?.proyectos" value="{{proy.id}}">{{proy.categoria}}</option>                                        
                                    </select>	
                                </div>	    						   
                                <div class="form-group">
                                    <button type="submit"  [disabled]="!agregausuariosinRform.form.valid" id="btn-contact" class="btn btn-primary btn-round btn-block">
                                      <i class="fa " aria-hidden="true" [ngClass]="{ 'fa-save':!loadingClienteR, ' fa-refresh fa-spin':loadingClienteR }"></i>
                                      Guardar
                                    </button>
                                </div>
                            </form>
                          </ng-template>
                        </ngb-tab>
                      </ngb-tabset>
                    </div>
                </div>
              </div>





              <div class="row">
             
                <div class="col-lg-12 col-md-12 col-12 col-sm-12">
                  <div class="card">
                    <div class="header">
                      <h2>Clientes</h2>		          
                    </div>
                    <div class="body">
                        <div class="">
                          <div class="row">
                            <table class="table table-striped">
                              <thead>
                                <tr>
                                  <th scope="col">Nombre del Cliente</th>
                                  <th scope="col">Proyecto</th>
                                  <th scope="col">Eliminar</th>
                                </tr>
                              </thead>
                              <tbody>				   
            
                                <tr *ngFor="let client of agregar_usuario?.clientes">
                                  <td>
                                    <div class="container">
                                      <div class="row">
                                        <p style="color:#a5a8ad">{{client.name}} {{client.last_name}}</p>
                                      </div>
                                      <div class="row">
                                        {{client.email}}
                                      </div>
                                    </div>
                                  </td>
                                  <td>{{client.categoria}}</td>
                                  <td>
                                    <button type="button" class="btn btn-danger btn-round" (click)="elimina_cliente_equipo(client.id_u_p)"><i class="fa fa-trash" aria-hidden="true"></i></button>
                                  </td>
                                </tr>  
                            
                                
                              </tbody>
                            </table>
            
                            </div>  
                        </div>  
                    </div>
                  </div>
                </div>
             </div>




            </div>
         
         </div>
        
         
         
        
        
        
        


       
        


        

        <!-- end contenido-->
    </div>
</div>